module.exports = __webpack_public_path__ + "img/page-7.35b39755.png";